export const RESERVATION_AD_ID_LOCAL_STORAGE_KEY = 'RESERVATION_AD_ID';
